import * as typeS from "../service/types";
import Swal from 'sweetalert2'
import { listChallengedTransactions } from "../service/ApiConfig";

export const listChallengedTransactionRequest = () => {
    return {
      type: typeS.LIST_CHALLENGED_TRANSACTION_REQUEST,
    };
  };
  
  export const listChallengedTransactionSuccess = (list) => {
    return {
      type: typeS.LIST_CHALLENGED_TRANSACTION_REQUEST_SUCCESS,
      payload: list,
    };
  };
  
  export const listChallengedTransactionError = (error) => {
    return {
      type: typeS.LIST_CHALLENGED_TRANSACTION_REQUEST_FAILED,
      payload: error,
    };
  };
  
  export const listChallengedTransactionData = (setLoading,clientid) => {
    return (dispatch) => {
      try {
        listChallengedTransactions(clientid).then((res) => {
          if (res && res.status === 200) {
            dispatch(listChallengedTransactionSuccess(res?.data?.data));
            setLoading(false)
          } else {
            dispatch(listChallengedTransactionError("err.message"));
            setLoading(false);
          }
        }).catch((err) => {
          dispatch(listChallengedTransactionError(err));
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: err,
          })
        });
      } catch (err) {
        // console.log(err);
      }
    };
  }
  